import * as apiBff from './bff'

export async function getMediaPicture(category: 'universe' | 'department', ids: number[]): Promise<Record<number, string | null>> {
  try {
    return await apiBff.callDirectBFF<Record<number, string | null>>('GET', `/media/${category}?id=${ids.join('&id=')}`)
  }
  catch {
    return Object.fromEntries(ids.map(id => [id, null]))
  }
}
